import { render, staticRenderFns } from "./CreateLeavesPopUp.vue?vue&type=template&id=6b0f83f4&scoped=true&"
import script from "./CreateLeavesPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateLeavesPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateLeavesPopUp.vue?vue&type=style&index=0&id=6b0f83f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f83f4",
  null
  
)

export default component.exports